import CardListWidget from './CardListWidget';
import Skeleton from './Skeleton';
import Icon from './Icon';

export default Object.assign(CardListWidget, { Skeleton, Icon });
